<!-- <header> e non <div>: e' la fascia di testa del sito, quindi il banner
     della pagina. Vedi i principi sui landmark del W3C: tutto il contenuto
     percepibile deve stare dentro un punto di riferimento. -->
<header class="layout-topbar"
    [ngClass]="{
        'border-bottom-none': layoutService.config().topbarTheme !== 'light'
    }"
>
    <div class="layout-topbar-start">
        <!-- I comandi della barra sono <button>: erano <a> senza href, che con
             Tab non si raggiungevano — da tastiera non si apriva nessun menu. -->
        <button
            type="button"
            #mobileMenuButton
            class="layout-menu-button dt-menu-mobile-only"
            (click)="onMenuButtonClick()"
            pRipple
            [attr.aria-label]="'Apri il menu' | translate"
        >
            <i aria-hidden="true" class="pi pi-bars"></i>
        </button>
        <button
                type="button"
                *ngIf="!layoutService.isHorizontal()"
                #menuButton
                class="layout-menu-button dt-menu-desktop-only"
                (click)="onMenuButtonClick()"
                pRipple
                [attr.aria-label]="'Apri il menu' | translate"
        >
            <i aria-hidden="true" class="pi pi-bars"></i>
        </button>
        <!-- logo = link alla home dell'area riservata, non al sito (scheda _1 cap. 2) -->
        <a class="dt-topbar-logo" routerLink="{{dashboard_link}}"
           [attr.aria-label]="'Doctorium — vai alla home' | translate">
            <img src="assets/layout/images/logo-poseidon.png" alt="Doctorium">
        </a>
        <!-- le iniziali sono aria-hidden, quindi il nome del pulsante va dato qui -->
        <button
            type="button"
            class="dt-menu-mobile-only"
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="scalein"
            leaveToClass="hidden"
            leaveActiveClass="fadeout"
            [hideOnOutsideClick]="true"
            [attr.aria-label]="'menu_utente_iniziali' | translate:{ iniziali: inizialiUtente }"
        >
            <!-- iniziali: aprono lo stesso menu del desktop (scheda _1 pag. 16) -->
            <app-avatar-iniziali [nome]="nome" size="sm"></app-avatar-iniziali>
        </button>
        <!-- Menu utente mobile: stesso pannello del desktop (scheda menu-destro) -->
        <div class="layout-topbar-menu dt-usermenu hidden">
            <div class="dt-usermenu-testa">
                <app-avatar-iniziali [nome]="nome"></app-avatar-iniziali>
                <div class="dt-usermenu-chi">
                    <span class="dt-usermenu-nome">{{ nome }}</span>
                    <span class="dt-usermenu-mail">{{ email }}</span>
                </div>
            </div>

            <ul class="dt-usermenu-voci list-none p-0 m-0">
                <li>
                    <button type="button" class="dt-usermenu-voce" (click)="goToProfilo()">
                        <i aria-hidden="true" class="pi pi-user"></i><span>{{ 'I tuoi dati' | translate }}</span>
                    </button>
                </li>

                <li *ngIf="this.ruolo != 'paziente'">
                    <button type="button" class="dt-usermenu-voce" (click)="goToCambiapassword()">
                        <i aria-hidden="true" class="pi pi-key"></i><span>{{ 'Cambia password' | translate }}</span>
                    </button>
                </li>

                <li *ngIf="this.ruolo == 'paziente'">
                    <button type="button" class="dt-usermenu-voce" (click)="goToModificaConsensi()">
                        <i aria-hidden="true" class="pi pi-file"></i><span>{{ 'Modifica consensi' | translate }}</span>
                    </button>
                </li>

                <li *ngIf="this.ruolo == 'paziente'">
                    <button type="button" class="dt-usermenu-voce" (click)="goToPrivacyConsulto()">
                        <i aria-hidden="true" class="pi pi-eye-slash"></i><span>{{ 'Privacy del consulto' | translate }}</span>
                    </button>
                </li>

                <li *ngIf="this.ruolo == 'paziente'" class="dt-usermenu-voce dt-usermenu-lingua">
                    <i aria-hidden="true" class="pi pi-flag"></i><label for="dt-lingua-mobile">{{ 'Lingua' | translate }}</label>
                    <select id="dt-lingua-mobile" [(ngModel)]="selectedLanguage" (change)="onLanguageChange($event)">
                        <option value="it">It</option>
                        <option value="en">En</option>
                        <!-- per ora il paziente ha solo italiano e inglese (12/10/2026):
                        <option value="fr">Fr</option>
                        <option value="de">De</option>
                        <option value="es">Es</option>
                        -->
                    </select>
                </li>

                <li>
                    <a href="https://doctorium.it/contatti" target="_blank" rel="noopener" class="dt-usermenu-voce">
                        <i aria-hidden="true" class="pi pi-question-circle"></i><span>{{ 'Assistenza' | translate }}</span>
                    </a>
                </li>

                <!-- unica voce distruttiva: rosso solo qui -->
                <li class="dt-usermenu-uscita">
                    <button type="button" class="dt-usermenu-voce dt-usermenu-voce-esci" (click)="logout()">
                        <i aria-hidden="true" class="pi pi-sign-out"></i><span>{{ 'Esci' | translate }}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <div class="layout-topbar-end surface-border flex">
        <div class="layout-topbar-actions-end">
            <ul class="layout-topbar-items">

                
                
                <li class="layout-topbar-profile">
                    <button
                        type="button"
                        *ngIf="!layoutService.isMobile()"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <!-- iniziali + nome e ruolo (scheda _1 pag. 16) -->
                        <div class="dt-topbar-user">
                            <app-avatar-iniziali [nome]="nome"></app-avatar-iniziali>
                            <div class="dt-topbar-user-txt">
                                <span class="dt-topbar-user-nome">{{ nome }}</span>
                                <span class="dt-topbar-user-ruolo">{{ ruoloEtichetta | translate }}</span>
                            </div>
                            <i class="pi pi-chevron-down dt-topbar-user-chevron" aria-hidden="true"></i>
                        </div>
                    </button>
                    <!-- Menu utente desktop (scheda menu-destro) -->
                    <div class="layout-topbar-menu dt-usermenu hidden">
                        <div class="dt-usermenu-testa">
                            <app-avatar-iniziali [nome]="nome"></app-avatar-iniziali>
                            <div class="dt-usermenu-chi">
                                <span class="dt-usermenu-nome">{{ nome }}</span>
                                <span class="dt-usermenu-mail">{{ email }}</span>
                            </div>
                        </div>

                        <ul class="dt-usermenu-voci list-none p-0 m-0">
                            <li *ngIf="this.ruolo == 'paziente' || this.ruolo == 'medico'">
                                <button type="button" class="dt-usermenu-voce" (click)="goToProfilo()">
                                    <i aria-hidden="true" class="pi pi-user"></i><span>{{ 'I tuoi dati' | translate }}</span>
                                </button>
                            </li>

                            <li *ngIf="this.ruolo != 'paziente'">
                                <button type="button" class="dt-usermenu-voce" (click)="goToCambiapassword()">
                                    <i aria-hidden="true" class="pi pi-key"></i><span>{{ 'Cambia password' | translate }}</span>
                                </button>
                            </li>

                            <li *ngIf="this.ruolo == 'paziente'">
                                <button type="button" class="dt-usermenu-voce" (click)="goToModificaConsensi()">
                                    <i aria-hidden="true" class="pi pi-file"></i><span>{{ 'Modifica consensi' | translate }}</span>
                                </button>
                            </li>

                            <li *ngIf="this.ruolo == 'paziente'">
                                <button type="button" class="dt-usermenu-voce" (click)="goToPrivacyConsulto()">
                                    <i aria-hidden="true" class="pi pi-eye-slash"></i><span>{{ 'Privacy del consulto' | translate }}</span>
                                </button>
                            </li>

                            <li *ngIf="this.ruolo == 'paziente'" class="dt-usermenu-voce dt-usermenu-lingua">
                                <i aria-hidden="true" class="pi pi-flag"></i><label for="dt-lingua-desktop">{{ 'Lingua' | translate }}</label>
                                <select id="dt-lingua-desktop" [(ngModel)]="selectedLanguage" (change)="onLanguageChange($event)">
                                    <option value="it">It</option>
                                    <option value="en">En</option>
                                    <!-- per ora il paziente ha solo italiano e inglese (12/10/2026):
                                    <option value="fr">Fr</option>
                                    <option value="de">De</option>
                                    <option value="es">Es</option>
                                    -->
                                </select>
                            </li>

                            <li>
                                <a href="https://doctorium.it/contatti" target="_blank" rel="noopener" class="dt-usermenu-voce">
                                    <i aria-hidden="true" class="pi pi-question-circle"></i><span>{{ 'Assistenza' | translate }}</span>
                                </a>
                            </li>

                            <!-- unica voce distruttiva: rosso solo qui -->
                            <li class="dt-usermenu-uscita">
                                <button type="button" class="dt-usermenu-voce dt-usermenu-voce-esci" (click)="dialog()">
                                    <i aria-hidden="true" class="pi pi-sign-out"></i><span>{{ 'Esci' | translate }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <p-dialog
            [(visible)]="showDialog"
            header="Conferma"
            [modal]="true"
            [style]="{ width: '450px' }"
    >
        <div class="flex align-items-center justify-content-center">
            <i aria-hidden="true"
                    class="pi pi-exclamation-triangle mr-3 dt-dialog-ico"
            ></i>
            <span>{{ 'Sicuro di voler uscire' | translate }}</span>
        </div>
        <ng-template pTemplate="footer">
            <button
                    pButton
                    pRipple
                    icon="pi pi-times"
                    class="p-button-outlined"
                    label="No"
                    (click)="showDialog = false"
            ></button>
            <button
                    pButton
                    pRipple
                    icon="pi pi-check"
                    class="p-button-text"
                    label="Sì"
                    (click)="logout()"
            ></button>
        </ng-template>
    </p-dialog>

</header>

